<template>
  <div class="contact-data simulator-view split-view fill-height">
    <v-row class="split-view__row fill-height" no-gutters>
      <left-side-image />
      <v-col cols="12" md="7" class="split-view__panel">
        <div class="split-view__scroll">
        <nav-bar-page />
        <v-container>
          <v-row justify="center" class="mt-0">
            <v-col cols="12" class="mt-0 py-0">
              <v-stepper alt-labels elevation="0">
                <v-stepper-header>
                  <v-stepper-step step="" class="active-step today-medium">
                    Póliza
                  </v-stepper-step>

                  <v-divider inset class="active-separator-step"></v-divider>

                  <v-stepper-step step="" class="active-step today-medium">
                    Simulador
                  </v-stepper-step>

                  <v-divider class="grey-separator-step"></v-divider>

                  <v-stepper-step step="" class="grey-step today-medium">
                    Formulario
                  </v-stepper-step>

                  <v-divider class="grey-separator-step"></v-divider>

                  <v-stepper-step step="" class="grey-step today-medium">
                    Firma de documentos
                  </v-stepper-step>

                  <v-divider class="grey-separator-step"></v-divider>

                  <v-stepper-step step="" class="grey-step today-medium">
                    Pago
                  </v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </v-col>
            <v-col class="text-center justify-center d-flex d-sm-none">
              <div class="text-h6 today-medium primary--text">Simulador</div>
            </v-col>
          </v-row>

          <template v-if="loading">
            <div class="d-flex justify-center mt-6">
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
                aria-label="Cargando simulador"
              ></v-progress-circular>
            </div>
          </template>
          <template v-else-if="!simulatorStatus">
            <p class="simulator-empty today-light primary--text">
              {{ simulatorMessage }}
            </p>
          </template>
          <template v-else>
            <v-row justify="center">
              <v-col cols="12" md="10" class="px-4">
                <section class="simulator-fields">
                  <div class="simulator-field">
                    <h2 class="simulator-field__label today-medium">
                      Valor de la póliza
                    </h2>
                    <p class="simulator-field__hint today-light">
                      Desde $ 100.000
                    </p>
                    <p class="simulator-field__value today-medium">
                      {{ formatCurrency(totalValuePolicy) }}
                    </p>
                  </div>
                  <div class="simulator-field">
                    <label
                      class="simulator-field__label today-medium"
                      for="simulator-term"
                    >
                      Plazo de financiación
                    </label>
                    <p class="simulator-field__hint today-light">
                      De {{ minFeeNumber }} a {{ maxFeeNumber }} meses
                    </p>
                    <v-select
                      id="simulator-term"
                      :items="items"
                      label="Cuotas"
                      outlined
                      dense
                      color="primary"
                      hide-details="auto"
                      autocomplete="off"
                      v-model="feeNumber"
                      v-on:change="newCalculateFee()"
                    ></v-select>
                  </div>
                </section>

                <section class="simulator-result">
                  <p class="simulator-result__kicker today-light">
                    Tu cuota mensual sería de
                  </p>
                  <p
                    class="simulator-result__amount today-medium"
                    aria-live="polite"
                  >
                    {{ formatCurrency(firstFeeValue) }}
                  </p>

                  <dl class="simulator-meta">
                    <div class="simulator-meta__row">
                      <dt>Tasa fija mes vencido</dt>
                      <dd>
                        {{ formatNumber(rate) }} % {{ rateType }}
                      </dd>
                    </div>
                    <div class="simulator-meta__row">
                      <dt>Cuota inicial obligatoria</dt>
                      <dd>{{ formatCurrency(firstFeeValue) }}</dd>
                    </div>
                  </dl>

                  <div class="simulator-actions">
                    <v-btn
                      class="simulator-btn simulator-btn--secondary today-medium"
                      elevation="0"
                      @click="payDialog = true"
                    >
                      Ver plan de pagos
                    </v-btn>
                    <v-btn
                      :loading="loadingFinance"
                      :disabled="loadingFinance"
                      class="simulator-btn simulator-btn--primary today-medium"
                      elevation="0"
                      @click="registerCellphone"
                    >
                      Financiar póliza
                    </v-btn>
                  </div>

                  <p class="simulator-disclaimer today-light">
                    *La información presentada es un cálculo aproximado basado
                    en la información suministrada y no constituye otorgamiento
                    de crédito. El estudio de la solicitud se realizará acorde
                    con las políticas de la aseguradora. Algunas condiciones
                    podrán variar sin previo aviso.
                  </p>
                </section>
              </v-col>
            </v-row>
          </template>
        </v-container>
        </div>
      </v-col>
    </v-row>

    <payment-plan
      :pay-plan="payPlan"
      :total-value-policy="totalValuePolicy"
      :fee-number="feeNumber"
      :dialog="payDialog"
      @close="payDialog = false"
    />
    <v-dialog
      v-model="registerCellphoneDialog"
      max-width="400"
      overlay-color="primary"
      content-class="simulator-phone-dialog"
      :persistent="loadingCellphone"
    >
      <v-card class="simulator-phone-card">
        <v-card-title
          class="justify-center text-uppercase primary--text font-weight-bold today-medium simulator-phone-card__title"
        >
          Registrar celular
        </v-card-title>
        <div class="px-10 px-md-12 pb-7">
          <p class="simulator-phone-card__hint today-light">
            Te enviaremos un código de verificación por SMS al número que
            registres.
          </p>

          <v-form ref="form" lazy-validation>
            <div v-if="!codeSent">
              <v-text-field
                v-model="cellphone"
                :rules="[rules.required, rules.counterMax, rules.counterMin]"
                type="tel"
                inputmode="numeric"
                autocomplete="tel"
                name="cellphone"
                label="Celular"
                maxlength="10"
                outlined
                dense
                color="primary"
                hide-details="auto"
                placeholder="Ej. 3001234567"
              ></v-text-field>
              <v-btn
                block
                :loading="loadingCellphone"
                :disabled="loadingCellphone"
                color="primary"
                class="simulator-btn simulator-btn--primary today-medium mt-7"
                elevation="0"
                @click="sendCellphone"
              >
                Enviar código
              </v-btn>
            </div>

            <div v-else>
              <v-row>
                <v-col
                  v-for="(key, i) in activationKeyFields"
                  :key="i"
                  cols="2"
                  class="px-1 text-center"
                >
                  <v-text-field
                    type="text"
                    inputmode="numeric"
                    autocomplete="one-time-code"
                    :spellcheck="false"
                    :data-length="key.length"
                    :data-index="i"
                    :ref="`input-${i}`"
                    v-model="key.value"
                    v-on:keyup="handleActivationInput($event)"
                    class="px-0 code-input"
                    outlined
                    dense
                    color="primary"
                    maxLength="1"
                    :aria-label="'Dígito ' + (i + 1) + ' del código'"
                  ></v-text-field>
                </v-col>
              </v-row>
              <p
                v-if="!reSendCode"
                class="simulator-phone-card__timer today-medium"
              >
                Se habilitará un nuevo código en 00:{{
                  String(countdown).padStart(2, "0")
                }}
              </p>
              <p v-else class="text-center">
                <a
                  href="#"
                  class="simulator-phone-card__resend today-regular"
                  @click.prevent="sendCellphone()"
                >
                  Reenviar código
                </a>
              </p>
              <v-btn
                block
                :loading="loadingCellphone"
                :disabled="loadingCellphone"
                color="primary"
                class="simulator-btn simulator-btn--primary today-medium mt-4"
                elevation="0"
                @click="sendValidateCode"
              >
                Verificar código
              </v-btn>
            </div>
          </v-form>
        </div>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :timeout="timeout" bottom right role="status">
      <div v-html="snackbarMessage"></div>
    </v-snackbar>
  </div>
</template>

<script>
import LeftSideImage from "@/components/Layouts/LeftSideImage";
import NavBarPage from "@/components/Layouts/NavBarPage";
import { api } from "@/helpers/axios";
import {
  constants,
  formatCurrency,
  formatDecimal,
  formatNumber,
} from "@/helpers/constants";
import { locals } from "@/helpers/locals";
import PaymentPlan from "@/components/PaymentPlan.vue";

export default {
  name: "Policy",
  components: { PaymentPlan, LeftSideImage, NavBarPage },
  data() {
    return {
      loading: true,
      cellphone: "",
      payDialog: false,
      registerCellphoneDialog: false,
      loadingCellphone: false,
      loadingFinance: false,
      codeSent: false,
      items: [2],
      firstFeeValue: 0,
      creditStudy: 0,
      insurance: 0,
      creditInsurance: 0,
      ivaValue: 0,
      iva: 0,
      othersFeeValue: 0,
      amortizedFee: 0,
      admin: 0,
      totalValuePolicy: 0,
      discountValue: 0,
      valueFinance: 0,
      feeNumber: 2,
      minFeeNumber: 0,
      maxFeeNumber: 0,
      typeFeeNumber: "",
      insuranceRate: 0,
      rate: 0,
      rateType: "",
      feeValue: 0,
      expires_in: 60,
      countdown: "",
      request: null,
      insurancePolicyId: null,
      snackbar: false,
      timeout: 3000,
      snackbarMessage: "",
      simulatorStatus: true,
      simulatorMessage: "",
      payPlan: [],
      activationKeyFields: [
        { length: 1, value: "" },
        { length: 1, value: "" },
        { length: 1, value: "" },
        { length: 1, value: "" },
        { length: 1, value: "" },
        { length: 1, value: "" },
      ],
      rules: {
        required: (value) => !!value || "Ingresa la información",
        counterMax: (value) =>
          value.length <= 10 || "Cantidad máxima 10 digitos",
        counterMin: (value) =>
          value.length == 10 || "Cantidad minima 10 digitos",
      },
      reSendCode: false,
    };
  },
  mounted() {},
  methods: {
    registerCellphone() {
      this.loadingFinance = true;
      api
        .get(constants.endPoints.phoneIsRegistered, true)
        .then((response) => {
          let dataResponse = response.data;
          if (dataResponse.status) {
            this.createRequest();
          } else {
            this.registerCellphoneDialog = true;
            this.loadingFinance = false;
          }
        })
        .catch(
          function (error) {
            try {
              let status = error.response.status;
              if (status === 401) {
                locals.clearLocal();
                this.$router.push("/");
              }
              let errors = error.response.data.errors;
              let message = "";
              for (var [key, value] of Object.entries(errors)) {
                console.log(key + " : " + value);
                message = message + value + "<br>";
              }
              this.snackbarMessage = message;
              this.snackbar = true;
              this.loading = false;
            } catch (e) {
              console.log(e);
              locals.clearLocal();
              this.$router.push("/");
            }
          }.bind(this)
        );
    },
    sendCellphone: function () {
      if (!this.codeSent) {
        const form = this.$refs.form;
        if (!form || !form.validate()) {
          return;
        }
      }

      this.loadingCellphone = true;
      this.reSendCode = false;

      api
        .post(
          constants.endPoints.registerPhone,
          {
            cellphone: this.cellphone,
          },
          true
        )
        .then((response) => {
          this.request.id = response.data.data.id;
          this.startCountDown();
          this.loadingCellphone = false;
          this.codeSent = true;
        })
        .catch((error) => {
          console.log("post", error);
          this.loadingCellphone = false;
          this.snackbarMessage =
            "No se pudo enviar el código. Inténtalo de nuevo.";
          this.snackbar = true;
        });
    },
    sendValidateCode: function () {
      this.loadingCellphone = true;

      let token = "";

      this.activationKeyFields.forEach((value) => {
        token = token + value.value;
      });

      console.log("token", token);

      if (token.length === 6) {
        api
          .post(
            constants.endPoints.validatePhone,
            {
              cellphone: this.cellphone,
              token: token,
            },
            true
          )
          .then((response) => {
            console.log(response);
            let dataResponse = response.data;
            if (dataResponse.status) {
              this.createRequest();
            } else {
              this.loadingCellphone = false;
              this.snackbarMessage = dataResponse.message;
              this.snackbar = true;
            }
          })
          .catch(() => {
            this.loadingCellphone = false;
            this.snackbarMessage =
              "No se pudo verificar el código. Inténtalo de nuevo.";
            this.snackbar = true;
          });
      } else {
        this.loadingCellphone = false;
        this.snackbarMessage = "El código debe tener 6 dígitos";
        this.snackbar = true;
      }
    },
    createRequest() {
      api
        .post(
          constants.endPoints.createRequest,
          {
            insurance_policy_id: this.insurancePolicyId,
            fee_number: this.feeNumber,
          },
          true
        )
        .then(
          (response) => {
            this.loadingFinance = false;
            this.request.id = response.data.data.id;
            locals.setLocal("request", JSON.stringify(this.request));
            this.$router.push("/formulario");
          },
          (error) => {
            console.log("post", error);
          }
        );
    },
    newCalculateFee() {
      this.valueFinance = parseInt(this.valueFinance, 10);
      const date = new Date();
      const _date = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      console.log(_date);
      api
        .post("https://tefio-vardi.bio.credit/calcularcuota", {
          data: {
            fecha: _date,
            valor: this.valueFinance,
            plazo: this.feeNumber,
            tasa: this.insuranceRate,
            portafolio_id: 10040,
            idvardi: this.request.id,
          },
        })
        .then((response) => {
          console.log(
            "calculo sigma",
            response,
            response.data.plan_pagos[0].cuota
          );
          this.feeValue = response.data.plan_pagos[0].cuota;
          this.amortizedFee = this.feeValue;
          this.firstFeeValue =
            this.amortizedFee +
            this.creditStudy +
            this.insurance +
            this.ivaValue;
          this.othersFeeValue = this.amortizedFee + this.admin;
          this.payPlan = response.data.plan_pagos;
          this.payPlan = this.payPlan.map((item) => {
            item.cuota = formatDecimal(item.cuota);
            item.saldo_final = formatDecimal(item.saldo_final);
            item.abono_capital = formatDecimal(item.abono_capital);
            return item;
          });
          this.payPlan.sort((a, b) => a.nro_cuota - b.nro_cuota);
        })
        .catch(
          function (error) {
            try {
              let status = error.response.status;
              if (status === 401) {
                locals.clearLocal();
                this.$router.push("/");
              }
              let errors = error.response.data.errors;
              let message = "";
              for (const [key, value] of Object.entries(errors)) {
                console.log(key + " : " + value);
                message = message + value + "<br>";
              }
              this.snackbarMessage = message;
              this.snackbar = true;
              this.loading = false;
            } catch (e) {
              console.log(e);
            }
          }.bind(this)
        );
    },
    formatCurrency: formatCurrency,
    formatNumber: formatNumber,
    startCountDown: function () {
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.countdown = this.expires_in;
      this.interval = setInterval(() => {
        if (this.countdown === 0) {
          clearInterval(this.interval);
          this.countdown = this.expires_in;
          this.reSendCode = true;
          //this.reSendSignatureOtp();
        } else {
          this.countdown -= 1;
          this.reSendCode = false;
        }
      }, 1000);
    },
    goNext(event) {
      console.log(this.$refs.digit2);
      this.$refs.digit2.focus();
    },
    handleActivationInput(event) {
      // Grab input's value
      let value = event.target.value;
      // Grab data-index value
      let index = parseInt(event.target.dataset.index);
      // Grab data-length value
      let maxlength = event.target.dataset.length;

      if (this.activationKeyFields[index].value.length > maxlength) {
        event.preventDefault();
        this.activationKeyFields[index].value = value.slice(0, 6);
        try {
          this.$refs[`input-${parseInt(index + 1)}`][0].focus();
        } catch (e) {}
        return;
      }

      // Shift focus to next input field if max length reached
      if (value.length >= maxlength) {
        if (typeof this.activationKeyFields[index + 1] == "undefined") {
          event.preventDefault();
          return;
        }
        this.$refs[`input-${parseInt(index + 1)}`][0].focus();
        event.preventDefault();
      }
      console.log(event, index, maxlength, this.activationKeyFields);
    },
    getSimulatorService(insurancePolicyId) {
      this.insurancePolicyId = insurancePolicyId;
      api
        .get(
          constants.endPoints.simulator +
            "?insurance_policy_id=" +
            insurancePolicyId,
          true
        )
        .then((response) => {
          this.loading = false;
          let simulator = response.data.data;
          this.simulatorStatus = response.data.status;
          this.simulatorMessage = response.data.message;

          if (this.simulatorStatus) {
            console.log("simulator", simulator);
            this.discountValue = simulator.discount;
            this.totalValuePolicy = parseInt(simulator.total_final, 10);
            this.valueFinance = parseInt(simulator.total_final, 10);
            this.insuranceRate = simulator.insurance_rate;
            this.rate = simulator.rate;
            this.rateType = simulator.rate_type;
            this.creditStudy = parseInt(simulator.credit_study, 10);
            this.admin = parseInt(simulator.administration, 10);
            this.creditInsurance = parseInt(simulator.credit_insurance, 10);
            this.iva = simulator.iva;

            this.minFeeNumber = simulator.min_fee_number;
            this.maxFeeNumber = simulator.max_fee_number;
            for (
              let i = parseInt(this.minFeeNumber);
              i <= parseInt(this.maxFeeNumber);
              i++
            ) {
              this.items.push(i);
            }
            this.typeFeeNumber = simulator.type_fee_number;

            this.newCalculateFee();
          }
        });
    },
    reSendSignatureOtp() {
      api
        .post(
          constants.endPoints.reSendSignatureOtp,
          {
            user_request_id: this.request.id,
          },
          true
        )
        .then((response) => {
          let dataResponse = response.data.data;

          this.snackbarMessage = dataResponse.otp.message;
          this.snackbar = true;

          this.startCountDown();

          console.log("reSendSignatureOtp", dataResponse);
        })
        .catch(
          function (error) {
            //
            console.log("errors: ", error);

            try {
              let status = error.response.status;
              if (status == 401) {
                locals.clearLocal();
                this.$router.push("/");
              }
              let errors = error.response.data.errors;
              let message = "";
              for (var [key, value] of Object.entries(errors)) {
                console.log(key + " : " + value);
                message = message + value + "<br>";
              }
              this.snackbarMessage = message;
              this.snackbar = true;
              this.loading = false;
            } catch (e) {
              console.log(e);
              locals.clearLocal();
              this.$router.push("/");
            }
          }.bind(this)
        );
    },
  },
  created: function () {
    this.insurancePolicyId = this.$route.params.insurancePolicyId;
    this.request = {};
    if (this.insurancePolicyId != null) {
      this.request.insurance_policy_id = this.insurancePolicyId;
      locals.setLocal("request", JSON.stringify(this.request));
      this.getSimulatorService(this.request.insurance_policy_id);
    } else {
      this.request = locals.getLocal("request");
      if (this.request) {
        this.getSimulatorService(this.request.insurance_policy_id);
      } else {
        this.$router.go(-1);
      }
    }
  },
  computed: {
    activationKey() {
      let value = "";
      for (let field of this.activationKeyFields) {
        value += field.value;
      }
      return value;
    },
  },
};
</script>

<style lang="scss">
.simulator-view {
  .simulator-empty {
    margin: 32px 16px 0;
    text-align: center;
    text-wrap: pretty;
  }

  .simulator-fields {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px 32px;
    margin-bottom: 24px;
  }

  .simulator-field__label {
    color: #00205b;
    display: block;
    font-size: 0.95rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    margin: 0 0 4px;
    text-wrap: balance;
  }

  .simulator-field__hint {
    color: rgba(0, 0, 0, 0.54);
    font-size: 0.8125rem;
    line-height: 1.4;
    margin: 0 0 10px;
  }

  .simulator-field__value {
    color: #00205b;
    font-size: 1.5rem;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.02em;
    line-height: 1.2;
    margin: 0;
    min-height: 40px;
  }

  .simulator-result {
    background: #f8f9fc;
    border: 1px solid #e6e8ee;
    border-radius: 16px;
    padding: 20px 20px 18px;
  }

  .simulator-result__kicker {
    color: rgba(0, 0, 0, 0.64);
    font-size: 0.875rem;
    line-height: 1.4;
    margin: 0 0 4px;
    text-wrap: pretty;
  }

  .simulator-result__amount {
    color: #00205b;
    font-size: 2.25rem;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.03em;
    line-height: 1.15;
    margin: 0 0 16px;
  }

  .simulator-meta {
    margin: 0 0 20px;
  }

  .simulator-meta__row {
    align-items: baseline;
    border-bottom: 1px solid #e8e8e8;
    display: grid;
    gap: 12px;
    grid-template-columns: minmax(0, 1.1fr) minmax(0, 0.9fr);
    padding: 10px 0;

    &:last-child {
      border-bottom: none;
    }
  }

  .simulator-meta dt {
    color: rgba(0, 0, 0, 0.64);
    font-family: "HelveticaNeue-Light", "Roboto-Light", sans-serif;
    font-size: 0.875rem;
    min-width: 0;
  }

  .simulator-meta dd {
    color: #00205b;
    font-family: "HelveticaNeue-Medium", "Roboto-Medium", sans-serif;
    font-size: 0.875rem;
    font-variant-numeric: tabular-nums;
    margin: 0;
    min-width: 0;
    overflow-wrap: anywhere;
    text-align: right;
  }

  .simulator-actions {
    align-items: stretch;
    display: flex;
    gap: 12px;
  }

  .simulator-btn {
    border-radius: 10px !important;
    flex: 1;
    font-size: 0.9375rem !important;
    height: 44px !important;
    letter-spacing: 0 !important;
    min-height: 44px;
    text-transform: none !important;
    touch-action: manipulation;
    transition-duration: 150ms;
    transition-property: transform, background-color, color, box-shadow,
      border-color, opacity;
    transition-timing-function: ease-out;
  }

  .simulator-btn:active:not(.v-btn--disabled) {
    transform: scale(0.96);
  }

  .simulator-btn--primary {
    background: #00205b !important;
    box-shadow: 0 1px 2px rgba(0, 32, 91, 0.18), 0 6px 16px rgba(0, 32, 91, 0.12);
    color: #ffffff !important;
  }

  .simulator-btn--primary:hover:not(.v-btn--disabled) {
    background: #001846 !important;
  }

  .simulator-btn--secondary {
    background: #ffffff !important;
    border: 1px solid #cfd5e4 !important;
    color: #00205b !important;
  }

  .simulator-btn--secondary:hover:not(.v-btn--disabled) {
    background: #eef1f7 !important;
    border-color: #00205b !important;
  }

  .simulator-btn.v-btn--disabled {
    opacity: 0.5;
  }

  .simulator-btn:focus-visible {
    outline: 2px solid #00205b;
    outline-offset: 3px;
  }

  .simulator-disclaimer {
    color: rgba(0, 0, 0, 0.54);
    font-size: 0.75rem;
    line-height: 1.45;
    margin: 16px 0 0;
    text-wrap: pretty;
  }

  .v-input input {
    font-size: 16px !important;
    font-variant-numeric: tabular-nums;
  }
}

.simulator-phone-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  overscroll-behavior: contain;
}

.simulator-phone-card {
  border-radius: 20px !important;
  overflow: hidden;
}

.simulator-phone-card__title {
  padding-top: 32px !important;
  text-wrap: balance;
}

.simulator-phone-card__hint {
  color: rgba(0, 0, 0, 0.64);
  font-size: 0.875rem;
  line-height: 1.45;
  margin: 0 0 20px;
  text-align: center;
  text-wrap: pretty;
}

.simulator-phone-card__timer {
  color: #00205b;
  font-size: 0.8125rem;
  font-variant-numeric: tabular-nums;
  margin: 4px 0 0;
  text-align: center;
}

.simulator-phone-card__resend {
  color: #00205b;
  display: inline-block;
  min-height: 44px;
  padding: 12px 0;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.simulator-phone-card .simulator-btn {
  border-radius: 10px !important;
  font-size: 0.9375rem !important;
  height: 44px !important;
  letter-spacing: 0 !important;
  min-height: 44px;
  text-transform: none !important;
  touch-action: manipulation;
  transition-duration: 150ms;
  transition-property: transform, background-color, color, box-shadow, opacity;
  transition-timing-function: ease-out;
}

.simulator-phone-card .simulator-btn:active:not(.v-btn--disabled) {
  transform: scale(0.96);
}

.simulator-phone-card .simulator-btn--primary {
  background: #00205b !important;
  box-shadow: 0 1px 2px rgba(0, 32, 91, 0.18), 0 6px 16px rgba(0, 32, 91, 0.12);
  color: #ffffff !important;
}

.simulator-phone-card .simulator-btn--primary:hover:not(.v-btn--disabled) {
  background: #001846 !important;
}

.simulator-phone-card .simulator-btn:focus-visible {
  outline: 2px solid #00205b;
  outline-offset: 3px;
}

.simulator-phone-card .code-input input {
  font-size: 1.125rem !important;
  font-variant-numeric: tabular-nums;
  text-align: center;
}

@media (prefers-reduced-motion: reduce) {
  .simulator-view .simulator-btn,
  .simulator-phone-card .simulator-btn {
    transition: none;
  }

  .simulator-view .simulator-btn:active:not(.v-btn--disabled),
  .simulator-phone-card .simulator-btn:active:not(.v-btn--disabled) {
    transform: none;
  }
}

.v-stepper__label {
  font-size: 13px;
}

.active-step .v-stepper__label {
  color: #00205b !important;
}

.active-step > span {
  min-width: 12px !important;
  height: 12px !important;
  width: 12px !important;
  background: #00205b !important;
}

.grey-step > span {
  min-width: 12px !important;
  height: 12px !important;
  width: 12px !important;
}

.v-stepper--alt-labels .v-stepper__header .v-divider {
  margin-top: 29px !important;
}

.active-separator-step {
  border-color: #00205b !important;
}

.grey-separator-step {
  border-color: rgba(0, 0, 0, 0.38) !important;
}

.v-divider {
  border-width: 1px 2px 2px !important;
}

.v-stepper--alt-labels .v-stepper__header .v-divider {
  margin: 29px -82px 0 !important;
}

@media (max-width: 600px) {
  .simulator-view .simulator-fields {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .simulator-view .simulator-field__value {
    font-size: 1.375rem;
  }

  .simulator-view .simulator-result {
    border-radius: 14px;
    padding: 16px;
  }

  .simulator-view .simulator-result__amount {
    font-size: 1.875rem;
  }

  .simulator-view .simulator-meta__row {
    gap: 2px;
    grid-template-columns: 1fr;
  }

  .simulator-view .simulator-meta dd {
    text-align: left;
  }

  .simulator-view .simulator-actions {
    flex-direction: column;
  }

  .v-stepper--alt-labels .v-stepper__step {
    flex-basis: 120px !important;
    padding: 5px !important;
  }

  .v-divider {
    visibility: hidden;
  }
}
</style>
